import { createFileRoute } from '@tanstack/react-router'
import { Helmet } from 'react-helmet-async'
import { TodaySummaryPage } from '@/features/reports/today-summary/today-summary-page'
import { formatDocumentTitle } from '@/lib/document-title'

/**
 * Reports › Today at `/$orgId/reports/today` (the mobile app and the Turns board link here). The Reports layout
 * gates it on report permission; it ignores the shared period — it is always today, refreshed every minute.
 */
export const Route = createFileRoute('/_auth/$orgId/reports/today')({
  component: TodayRoute,
})

function TodayRoute() {
  const { orgId } = Route.useParams()
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Today')}</title>
      </Helmet>
      <TodaySummaryPage orgId={orgId} />
    </>
  )
}
